import { PaymentDetail } from "@features/cx/payments/types";
import { getAddressStringForConsumer } from "@features/cx/shared/utils/filters";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Separator } from "@shared/ui/separator";
import { Mail, MapPin, Phone, User } from "lucide-react";
import { formatTerritoryAddress } from "@shared/utils/address";
interface CustomerInformationCardProps {
  payment: PaymentDetail;
}

export function CustomerInformationCard({
  payment,
}: CustomerInformationCardProps) {
  console.log("Payment Data in CustomerInformationCard:", payment); 
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <User className="h-5 w-5" />
          Customer Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-muted-foreground">Customer Name</p>
            <p className="font-medium">
              {payment?.consumer?.firstName || ""}{" "}
              {payment?.consumer?.lastName || ""}
            </p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Account Number</p>
            <p className="font-medium">
              {payment?.consumer?.consumerNo || "N/A"}
            </p>
          </div>
        </div>

        {/* Mock additional customer details */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-2">
          <div className="flex items-center gap-2">
            <MapPin className="h-4 w-4 text-muted-foreground" />
            {/* <div>
              <p className="text-xs text-muted-foreground">Service Address</p>
              <p className="text-sm">
                {payment?.serviceAddress?.state} ,{" "}
                {payment?.serviceAddress?.area} ,{" "}
                {payment?.serviceAddress?.subArea} ,{" "}
                {payment?.serviceAddress?.premise}
              </p>
            </div> */}
            <div>
  <p className="text-xs text-muted-foreground">Service Address</p>
 <div className="flex items-center gap-1 text-sm">
  <MapPin className="h-4 w-4 text-gray-400" />
  <span>
    {formatTerritoryAddress(
      { service: payment?.serviceAddress }, 
      "service"
    ) || "No address configured"}
  </span>
</div>
</div>
          </div>
          <div className="flex items-center gap-2">
            <Phone className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-xs text-muted-foreground">Phone</p>
              <p className="text-sm">
                {payment?.consumer?.contactNumber || "N/A"}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Mail className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-xs text-muted-foreground">Email</p>
              <p className="text-sm">{payment?.consumer?.email || "N/A"}</p>
            </div>
          </div>
        </div>

        <Separator />

        <div className="text-xs text-muted-foreground bg-muted p-3 rounded">
          <p>
            This payment has been processed and recorded in the system. For any
            disputes or inquiries, please contact customer service with the
            receipt number provided above.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
